import { __awaiter } from "tslib";
import Action from "../Action";
import text from "../../../store/text";
import { TTS_ENABLED } from "../Conditions";
import speechSynthesis from "../../../util/speechSynthesis";
import { language, ttsSpeed, ttsVoice } from "../../../store/settings";
export default class ReadStep extends Action {
    constructor(step) {
        super();
        this._name = "ReadStep";
        this.step = step;
        this.condition(TTS_ENABLED);
    }
    action(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            let resolve;
            ReadStep.utteranceEndedPromise = new Promise(res => (resolve = res));
            speechSynthesis.read(text.get().steps[this.step].tts, ttsSpeed.get(), speechSynthesis.getAvailableVoices(language.get()).find(voice => voice.name === ttsVoice.get()), () => resolve());
        });
    }
    toString() {
        return `${super.toString()}, step: ${this.step}`;
    }
}
